import TopPoster from 'components/body/TopPoster'
import GoogleTagManagerAttributes from 'components/core/GoogleTagManagerAttributes'
import ContactSupportForm from 'components/forms/ContactSupportForm'
import SingleTextHero from 'components/hero/SingleTextHero'
import Footer from 'components/layout/Footer'
import MainMenu from 'components/layout/MainMenu'
import TopMenuBar from 'components/layout/TopMenuBar'
import Env from 'Env'
import { TopPosterModel } from 'models/body/TopPosterModel'
import { MenuModel } from 'models/menu/MenuModel'
import { GetStaticProps, NextPage } from 'next'
import Head from 'next/head'
import React, { Fragment } from 'react'
import { ApiPromise } from 'services/ApiPromise'
import { Converters } from 'services/Converters'

type Props = {
  menu: MenuModel
  footer: MenuModel
  posters: {
    data: TopPosterModel[]
  }
}

const ContactForm: NextPage<Props> = (props) => {
  return (
    <Fragment>
      <GoogleTagManagerAttributes />
      <Head>
        <title>Contact Support Form</title>
      </Head>
      <GoogleTagManagerAttributes />
      {props.posters.data.map((poster, index) => (
        <TopPoster key={index} data={poster} />
      ))}
      <TopMenuBar />
      <MainMenu menu={props.menu} />
      <SingleTextHero className='support-banner' data={{ title: 'Contact Support', subtitle: "We're happy to help you" }} />
      <ContactSupportForm />
      <Footer data={props.footer} />
    </Fragment>
  )
}

export const getStaticProps: GetStaticProps = async () => {
  const allPromise = ApiPromise.Layout.GetMainAndFooterMenu()
  const [menuPromise, footerPromise, postersPromise] = await Promise.all(allPromise)
  const [menu, footer, posters] = Converters.KeysConvert.ConvertAllToLower([menuPromise.data, footerPromise.data, postersPromise.data])

  return { props: { menu, footer, posters }, revalidate: Env.PropsRevalidateTime }
}

export default ContactForm
